import { formatSelect } from '../Forms/utils';
import { getFullName } from '../Person/utils';

const getRemoteDoormanCalls = (state) => state?.remoteDoorman || {};
const getCallCenterAgentsLog = (state) => state?.callCenterAgents?.log || [];
const getCallCenterAgentList = (state) => state?.callCenterAgents?.list || {};
const getPopUpList = (state) => state?.popUp?.list || {};
const getCallCenterAgentOptions = (state, isWithExternal) => {
  const callCenterAgentsList = state?.callCenterAgents?.list?.results || [];
  const options = [...formatSelect(callCenterAgentsList)];
  if (isWithExternal) {
    options.push({ label: 'External', value: 'external' });
  }
  return options;
};
const getServiceUsers = (state) => state?.callCenterAgents?.serviceUsers || [];
const getServiceUsersOptions = (state) =>
  getServiceUsers(state)?.map((user) => ({
    label: getFullName(user),
    value: user?.id,
  }));

export {
  getRemoteDoormanCalls,
  getCallCenterAgentsLog,
  getCallCenterAgentList,
  getCallCenterAgentOptions,
  getServiceUsers,
  getServiceUsersOptions,
  getPopUpList,
};
